<template>
    <b-button variant="outline-primary" @click="openCustomizeFieldModal()">
        <b-spinner small v-if="checkLoading || uploading"></b-spinner>
        <i v-else-if="uploaded" class="fa-solid fa-cloud-arrow-up"></i>
        <i v-else-if="checked" class="fa-regular fa-circle-check"></i>
        <i v-else class="fa-solid fa-sliders"></i>
        <CustomizeFields ref="customizeFields" :collection="collection"
                         :localstorage-key="localstorageKey"
                         @change="whenChange"
                         @clear="handleClear"></CustomizeFields>
    </b-button>
</template>

<script>
import CustomizeFields from "@/components/common/mini-table/cells/CustomizeFields.vue";
import jsonShareCenterMixins from "@/mixin/common/json-share-center-mixins";
import moment from "moment";

export default {
    name: "CustomizeFieldsWithBtn",
    components: {CustomizeFields},
    mixins: [jsonShareCenterMixins],
    props: {
        collection: Array,
        currentOrder: Array,
        localstorageKey: String,
    },
    data() {
        return {
            uploaded: false,
            checked: false,
        }
    },
    computed: {
        lastModifyTimeLSKey() {
            return this.localstorageKey + "-lastModifyTime";
        },
        lastModifyTime() {
            return localStorage[this.lastModifyTimeLSKey];
        },
    },
    mounted() {
        this.getCheck();
    },
    methods: {
        openCustomizeFieldModal() {
            this.$refs.customizeFields.show();
        },
        whenChange() {
            localStorage[this.lastModifyTimeLSKey] = moment(new Date()).format(this.$t("em.datetime.format.viewMode"));
            this.upload();
            this.$emit('change');
        },
        upload() {
            let config = localStorage[this.localstorageKey]
            if (config && config.length > 0) {
                this.$_upload({
                    identifyCode: 'mini-table-custom-fields',
                    key: this.localstorageKey,
                    configuration: config,
                    lastModifyTime: this.lastModifyTime
                }).then(() => {
                    this.uploaded = true;
                    setTimeout(() => this.uploaded = false, 2000);
                });
            }
        },
        getCheck() {
            this.$_check('mini-table-custom-fields', this.localstorageKey, this.lastModifyTime).then(res => {
                if (res.noRemoteVersion || res.isBeyond) {
                    this.upload();
                } else if (res.hasNew) {
                    let dto = res.configuration;
                    localStorage[this.localstorageKey] = dto.configuration;
                    localStorage[this.lastModifyTimeLSKey] = dto.lastModifyTime;
                    this.$emit('change');
                    this.showChecked();
                }
            });
        },
        showChecked() {
            this.checked = true;
            setTimeout(() => this.checked = false, 2000);
        },
        handleClear() {
            localStorage[this.lastModifyTimeLSKey] = undefined;
        },
    }
}
</script>

<style scoped>

</style>
